<div class="card-inner-padding login-form-content">
  <form (ngSubmit)="loginSubmit()">
    <mat-card-content class="p-2 mb-0">
      <mat-form-field appearance="outline" class="login-input-field">
        <mat-icon matPrefix>person_outline</mat-icon>
        <input matInput [(ngModel)]="usuario.NomUsuario" placeholder="Usuario" name="username" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="login-input-field">
        <mat-icon matPrefix>lock_outline</mat-icon>
        <input matInput [(ngModel)]="usuario.Pass" placeholder="Contraseña" type="password" name="password" required>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions class="p-2 text-center">
      <button class="btn-block login-submit-button" mat-raised-button color="primary">Ingresar</button>
      <button mat-button (click)="volver()" type="button" class="login-back-button">
        Volver
      </button>
    </mat-card-actions>
  </form>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="mostrarProgressBar"></mat-progress-bar>
